import { render, staticRenderFns } from "./PanelInvoiceRemove.vue?vue&type=template&id=2ba5848e&scoped=true&"
import script from "./PanelInvoiceRemove.vue?vue&type=script&lang=js&"
export * from "./PanelInvoiceRemove.vue?vue&type=script&lang=js&"
import style0 from "./PanelInvoiceRemove.vue?vue&type=style&index=0&id=2ba5848e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba5848e",
  null
  
)

export default component.exports